module.exports = __webpack_public_path__ + "img/mascotte@0.5x.6caf1902.png";